export const adjective = [
  '인성이 파탄난',
  '일 하기 싫은',
  '안달난',
  '개가 짖을까봐 조마조마한',
  '산책하는',
  '수석입학한',
  '논리적인',
  '어제 잠을 잘 못잔',
  '졸고있는',
  '얼죽아',
  '고통받는',
  '친구가 많은',
  '누워있는',
  '지친',
  '꺼벙이안경을 쓴',
  '수염난',
  '매일 아이스크림을 사는',
  '빈둥거리는',
  '코딩하는',
  '길에서 외국인을 만난',
  '땀 흘리는',
  '무슨 말을 해도 안 웃긴',
  '외계에서 온',
  '물을 많이 마시는',
  '입에 가뭄이 온',
  '도넛이 좋은',
  '책 읽는 척 하는',
  '거짓투성이',
  '과장님한테 혼난',
  '집에 가고싶은',
  '간지나는',
  '허리가 아픈',
  '다리가 아픈',
  '어깨가 결린',
  '그저 눕고싶은',
  '할 말은 해야하는',
  '바나나 알러지가 있는',
  '모든 것이 귀찮은',
  '사람을 홀리는',
  '결벽증이 있는',
  '손을 씻고 있는',
  '핸드폰 없이 못 사는',
  '여행이 가고 싶은',
];
export const noun = [
  '호두파이',
  '뚱이',
  '징징이',
  '스펀지밥',
  '도라에몽',
  '우산',
  '멘홀 뚜껑',
  '세균맨',
  '호빵맨',
  '식빵맨',
  '필통',
  '노진구',
  '손목시계',
  '디즈니',
  '픽사',
  '강아지',
  '고양이',
  '집사',
  '동반자',
  '해바라기씨',
  '연필',
  '아이폰',
  '아이패드',
  '갤럭시',
  '팽수',
  '뚝딱이',
  '뿡뿡이',
  '번개맨',
  '마카롱',
  '조각 케이크',
  '노란 안경',
  '지갑',
  '머리끈',
  '에어팟',
  '헤드셋',
  '흰둥이',
  '삐약이',
  '모자',
  '소나기',
  '발바닥',
  '후드티',
  '토토로',
  '엘사',
  '안나',
  '올라프',
  '미키 마우스',
  '햄스터',
  '지구',
  '짱구',
  '토성',
  '금성',
  '타이탄',
  '별자리',
  '하늘',
  '구름',
  '바밤바',
];
export const emoji = [
  '🐶',
  '🐱',
  '🐭',
  '🐹',
  '🐰',
  '🦊',
  '🐻',
  '🐼',
  '🐻‍❄️',
  '🐨',
  '🐯',
  '🦁',
  '🐮',
  '🐷',
  '🐸',
  '🐧',
  '🐦',
  '🐔',
  '🐤',
  '🐺',
  '🐗',
  '🐴',
  '🦄',
  '🐽',
  '🦉',
  '🐟',
  '🌸',
  '🌼',
  '🌻',
  '🔥',
  '✨',
  '🍏',
  '🍎',
  '🍐',
  '🍊',
  '🍋',
  '🍌',
  '🍉',
  '🍇',
  '🍓',
  '🫐',
  '🍒',
  '🍑',
  '🥭',
  '🍍',
  '🥥',
  '🥝',
  '🥦',
  '🥬',
  '🥯',
  '🥐',
  '🍞',
  '🥨',
  '🧀',
  '🥞',
  '🍔',
  '🌭',
  '🍟',
  '🍕',
  '🥪',
  '🍩',
  '🍰',
  '🎂',
  '🍪',
  '🍿',
  '🍭',
  '🍯',
  '⚽️',
  '🏀',
  '🏈',
  '⚾️',
  '🎾',
  '🏐',
  '🎱',
  '🏓',
  '🪁',
  '🪀',
  '🎹',
  '🎬',
  '🎨',
  '🚗',
  '🚕',
  '🚙',
  '🚌',
  '🚎',
  '🚓',
  '💌',
  '🩷',
  '❤️',
  '🧡',
  '💛',
  '💚',
  '🩵',
  '💙',
  '💜',
  '🖤',
  '🩶',
  '🤍',
  '🤎',
  '💔',
  '❤️‍🔥',
  '❤️‍🩹',
  '❣️',
  '💕',
  '💞',
  '💓',
  '💗',
  '💖',
  '💘',
  '💝',
];
